import { AxiosError, AxiosInstance } from 'axios'

import { createAuthedHttpClient } from '@driftt/web-auth'

import config from 'config'
import { captureExceptionWithMessage } from 'utils/logRocket'

const logErrorHandler = (error: AxiosError) => {
  captureExceptionWithMessage('Conversation API Error', error, {
    url: window.location.href,
    endpoint: error.config.url,
    errorData: JSON.stringify(error.config)
  })
}

const responseErrorHandlers = [logErrorHandler]

export const ConversationApi: AxiosInstance = createAuthedHttpClient({
  responseErrorHandlers,
  baseConfig: {
    baseURL: config.CONVERSATION_API
  }
})
export const fetchSalesforceByDomain = async (domain: string) => {
  return ConversationApi.get(`/salesforce/enrichment?domain=${encodeURIComponent(domain)}`).then(
    res => res.data
  )
}

export const fetchSalesforceByAccount = async (email: string) => {
  return ConversationApi.get(`/salesforce/enrichment?email=${encodeURIComponent(email)}`).then(
    res => res.data
  )
}

export const fetchSalesforceRefreshFieldsById = async (endUserId: string, attributeDefs: any) => {
  return ConversationApi.post(
    `/salesforce/sync/sidebar/refresh?enduserid=${encodeURIComponent(endUserId)}`,
    attributeDefs
  ).then(res => res.data)
}
